export const ShopCardInitialState = {
  currentShopCardId: "",
};

export interface shopCardType {
  currentShopCardId?: string;
}
